import React, { createContext, useState, useContext, useEffect } from "react";

const ClinicianDetailsFormContext = createContext();

export const ClinicianDetailsFormStates = {
  initial: "initial",
  editing: "editing",
  canceling: "canceling",
  onsubmit: "onsubmit",
  loading: "loading",
  submitSuccess: "submitSuccess",
};

export const ClinicianDetailsFormProvider = ({ editMode, currentTab, children }) => {
  const [formState, setFormState] = useState("initial");

  useEffect(() => {
    if (editMode && formState === ClinicianDetailsFormStates.initial) {
      setFormState(ClinicianDetailsFormStates.editing);
    }
  }, [editMode]);

  useEffect(() => {
    if (currentTab) {
      setFormState(ClinicianDetailsFormStates.initial);
    }
  }, [currentTab]);

  // This is called by the save button, the child form will react to it and proceed to submit the data
  const onSubmit = () => {
    setFormState(ClinicianDetailsFormStates.onsubmit);
  };

  // Once the child form submits the data it calls this method to show loading icons on the save button for example
  const onSubmitting = () => {
    setFormState(ClinicianDetailsFormStates.loading);
  };

  // Once the child form submits the data with no error it calls this method
  const onSubmitSuccess = () => {
    // handle success globally
    // In case other parts of the tab/page need to react to this we can have a
    // onSubmitSuccess formState as well
    setFormState(ClinicianDetailsFormStates.submitSuccess);
  };

  // If the child form submits the data with error it calls this method
  const onSubmitError = () => {
    // handle error globally
    // In case other parts of the tab/page need to react to this we can have a
    // onSubmitError formState as well
    setFormState(ClinicianDetailsFormStates.editing);
  };

  const onCancelEdit = () => {
    setFormState(ClinicianDetailsFormStates.canceling);
  };

  const resetState = () => {
    setFormState(ClinicianDetailsFormStates.initial);
  };

  return (
    <ClinicianDetailsFormContext.Provider
      value={{
        formState,
        loading: formState === "loading",
        onSubmitting,
        onSubmit,
        onSubmitSuccess,
        onSubmitError,
        onCancelEdit,
        resetState,
      }}
    >
      {children}
    </ClinicianDetailsFormContext.Provider>
  );
};

export const useClinicianDetailsForm = () => useContext(ClinicianDetailsFormContext);
